import request from '../utils/request'
const serviceName = 'hkmgr'

// 获取预警列表
export function getWarnTree(data) {
  return request({
    // url:`/${serviceName}/hkSafetyWarning/getSafetyWarningInfoList`,
    url:'/warningMsg/getWarningMsgList',
    method:'get',
    params:data
  })
}
// 获取预警列表V2
export function getParticipate(data) {
    return request({
      url:'/rule/warn/workbench/participate',
      method:'get',
      params:data
    })
  }
 // 安全预警状态变更
export function changeStatus(data) {
    return request({
      // url:`/${serviceName}/hkSafetyWarning/changeStatus`,
      url:'/warningMsg/changeStatus',
      method:'post',
      params:data
    })
  }
  //获取安全预警配置列表
  export function getWarnconfig() {
    return request({
      // url:`/${serviceName}/hkSafetyWarning/getSafetyWarningConfigList`,
      url:'/warningMsg/getWarningConfigList',
      method:'get',
    })
  }
  // 保存安全配置
  export function saveconfig(data) {
    return request({
      url:`/${serviceName}/hkSafetyWarning/saveSafetyWarningConfig`,
      method:'post',
      data:data
    })
  }
  // 删除配置
  export function deleteconfig(data) {
    return request({
      url:`/${serviceName}/hkSafetyWarning/deleteSafetyWarningConfig`,
      method:'delete',
      params:data
    })
  }



// WEBPACK FOOTER //
// ./src/api/warnMessage.js